export const EMP_CLIENTES_LOADING = "EMP_CLIENTES_LOADING";
export const EMP_CLIENTES_SET_LISTA = "EMP_CLIENTES_SET_LISTA";
export const EMP_CLIENTES_SET_EMP = "EMP_CLIENTES_SET_EMP";
export const EMP_CLIENTES_SET_PAGE = "EMP_CLIENTES_SET_PAGE";
export const EMP_CLIENTES_SET_PERPAGE = "EMP_CLIENTES_SET_PERPAGE";
export const EMP_CLIENTES_SET_TOTAL = "EMP_CLIENTES_SET_TOTAL";
export const EMP_CLIENTES_SET_FILTRO = "EMP_CLIENTES_SET_FILTRO";
export const EMP_CLIENTES_SET_EXTRATO = "EMP_CLIENTES_SET_EXTRATO";
